<template>
  <div :class="classes">
    <slot></slot>
  </div>
</template>
<script>
import { PREFIX_CLASS } from '../../utils/constants'

const PREFIX_STEPS_CLASS = `${PREFIX_CLASS}steps`
const ERROR = 'error'
const PROCESS = 'process'
const FINISH = 'finish'
const WAIT = 'wait'
const STATUS = [ERROR, PROCESS, FINISH, WAIT]
const DIRECTION = ['horizontal', 'vertical']

export default {
  name: 'TStep',
  props: {
    current: {
      type: Number,
      validator(value) {
        return (value >= 0) && (value.toString().indexOf('.') < 0)
      },
      default: 0
    },
    size: {
      type: String,
      validator(value) {
        return [ 'sm', '' ].includes(value)
      },
      default: ''
    },
    status: {
      type: String,
      validator(value) {
        return STATUS.indexOf(value) >= 0
      },
      default: 'process'
    },
    direction: {
      type: String,
      default: DIRECTION[0],
      validator(value) {
        return DIRECTION.indexOf(value) !== -1
      }
    },
    labelVertical: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentState: this.current
    }
  },
  computed: {
    classes() {
      var classArr = [
        `${PREFIX_STEPS_CLASS}`,
        `${PREFIX_STEPS_CLASS}--${this.direction}`,
        {
          [`${PREFIX_STEPS_CLASS}--${this.size}`]: this.size
        },
        {
          [`${PREFIX_STEPS_CLASS}--label-vertical`]: this.labelVertical && this.direction !== 'vertical'
        }
      ]
      return classArr
    }
  },
  watch: {
    current(value) {
      this.currentState = value
    },
    currentState() {
      this.$_updateChildProps()
    },
    status() {
      this.$_updateCurrent()
    }
  },
  mounted() {
    this.$on('step-destroyed', () => {
      this.$_updateChildProps()
    })
    this.$on('step-mounted', (step) => {
      this.$_updateChildProps()
    })
    this.$_updateChildProps(true)
    this.$_setNextError()
    this.$_updateCurrent(true)
  },
  methods: {
    setCurrent(currentId) {
      this.currentState = currentId
    },
    $_updateStepStatus(step, stepIndex) {
      if (stepIndex === this.currentState) {
        if (this.status !== ERROR) {
          step.status = PROCESS
        } else {
          step.status = ERROR
        }
      } else if (stepIndex < this.currentState) {
        step.status = FINISH
      } else {
        step.status = WAIT
      }
    },
    $_updateChildProps(isInit) {
      this.$children.forEach((child, index) => {
        child.stepNumber = index + 1
        child.isLast = (child.stepNumber === this.$children.length)

        if (!(isInit && child.status)) {
          this.$_updateStepStatus(child, index)
        }

        if (child.status !== ERROR && index !== 0) {
          this.$children[index - 1].nextError = false
        }
      })
    },
    $_setNextError() {
      this.$children.forEach((child, index) => {
        if (child.status === ERROR && index !== 0) {
          this.$children[index - 1].nextError = true
        }
      })
    },
    $_updateCurrent(isInit) {
      if (this.$children[this.currentState]) {
        if (isInit) {
          let currentStatus = this.$children[this.currentState].status
          if (!currentStatus) {
            this.$children[this.currentState].status = this.status
          }
        } else {
          this.$children[this.currentState].status = this.status
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/steps/step.vue